import axios from 'axios';
import React, { useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import Button from '../Button';
import './OauthButton.scss';
import PropTypes from 'prop-types';

/**
 * @typedef OauthButtonProps
 * @property {'facebook'|'youtube_publication'|'google_oauth2'|'salesforce'} platform
 * @property {string} text
 * @property {string} link
 * @property {boolean} disconnect
 * @property {function} afterDisconnect
 * @property {boolean} disabled
 * @property {'primary'|'secondary'|'tertiary'} variant
 *
 * @param {OauthButtonProps} props
 * @returns
 */
const OauthButton = ({
  platform,
  text,
  link,
  disconnect,
  afterDisconnect = () => { },
  disabled = false,
  variant = 'primary',
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const callbackUrl = `/influencers${location.pathname}`;

  const handleClick = useCallback(() => {
    if (disconnect) {
      let disconnectHash = {};

      if (platform == 'facebook')
        disconnectHash = { fb_hash: null };
      else if (platform == 'youtube_publication' || platform == 'google_oauth2')
        disconnectHash = { yout_hash: null };

      axios.patch(`/api/v1/influencers/users/${user.id}`, {
        user: disconnectHash
      }).then(({ data }) => {
        afterDisconnect(data);
      }).catch((e) => console.log(e));

      return;
    }

    let oauthPath = null;
    switch (platform) {
      case 'youtube_publication':
        oauthPath = `/users/registration/youtube_auth/youtube_publication?callback_url=${callbackUrl}`;
        break;
      case 'google_oauth2':
        oauthPath = `/users/registration/youtube_auth/google_oauth2?callback_url=${callbackUrl}`;
        break;
      case 'salesforce':
        oauthPath = `/users/registration/salesforce_auth?callback_url=${callbackUrl}`;
        break;
      case 'facebook':
        oauthPath = `/users/registration/facebook_auth?callback_url=${callbackUrl}`;
        break;
      case 'walmart':
        oauthPath = '/agents/oauths/walmart_auth?authenticate=true'
        break;
      default:
        oauthPath = `#`;
    }
    window.location.href = oauthPath;
  }, [platform]);

  return (
    <React.Fragment>
      {link ?
        <Button
          variant="tertiary"
          onClick={handleClick}
          disabled={disabled}
        >
          <span className="text-underline">
            {text || t(`influencers.common.oauth_${platform}`)}
          </span>
        </Button> :
        <Button
          variant={variant}
          onClick={handleClick}
          className={`${platform}_btn`}
          disabled={disabled}
        >
          {text || t(`influencers.common.oauth_${platform}`)}
        </Button>
      }
    </React.Fragment>
  );
};


OauthButton.propTypes = {
  platform: PropTypes.oneOf(['facebook', 'youtube_publication', 'google_oauth2', 'salesforce', 'walmart']).isRequired,
  text: PropTypes.any,
  link: PropTypes.bool,
  disconnect: PropTypes.bool,
  afterDisconnect: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};
export default React.memo(OauthButton);
